import { endOfDay, parseISO } from "date-fns";
import { fromZonedTime, toZonedTime } from "date-fns-tz";
import { includesTimeOfDay } from "./includesTimeOfDay.js";
const TIME_ZONE = "Europe/Oslo";
/**
 * Resolves the effective cancellation deadline (avbestillingsfrist).
 *
 * - Deadlines with an explicit time (ISO datetime) keep that exact time.
 * - Date-only deadlines expire at the end of the Norwegian day (23:59:59.999).
 */
export const resolveSkipBookDeadline = (deadline) => {
    const parsed = parseISO(deadline);
    if (includesTimeOfDay(deadline)) {
        return parsed;
    }
    return fromZonedTime(endOfDay(toZonedTime(parsed, TIME_ZONE)), TIME_ZONE);
};
